import { Layout, Modal } from 'antd';
import { Outlet } from 'react-router-dom';
import { useCallback, useState } from 'react';
import Sidebar from './sidebar';
import styles from './index.module.less';
import { useVerifyModalStore } from '@store/verifyModalStore';

const { Sider, Content } = Layout;

function App(props: any) {
    const [collapsed, setCollapsed] = useState<boolean>(false);
    const { visible, hideVerifyModal } = useVerifyModalStore();

    const handleCollapse = useCallback((collapsed: boolean) => {
        setCollapsed(collapsed);
    }, []);

    return (
        <Layout className={styles.layout}>
            <Sider
                className={styles.sider}
                width={260}
                collapsible
                collapsed={collapsed}
                onCollapse={handleCollapse}
                trigger={null}
                collapsedWidth={62}
            >
                <Sidebar collapsed={collapsed} onCollapse={handleCollapse} />
            </Sider>
            <Content id="pc-content" className={styles.content}>
                <Outlet />
            </Content>
            {/* 认证引导弹窗（全局） */}
            <Modal
                open={visible}
                onCancel={hideVerifyModal}
                footer={null}
                centered
                closable={false}
                width={700}
                className={styles.verifyModal}
                zIndex={1100}
            >
                <img
                    src="https://med-fe.cdn.bcebos.com/fe-doctor-workbench/authmodal.png"
                    alt="认证提示"
                    className={styles.verifyImage}
                    onClick={hideVerifyModal}
                />
            </Modal>
        </Layout>
    );
}

export default App;
